module.exports = __webpack_public_path__ + "static/media/spinner.0427c8a2.svg";